export default "__VITE_ASSET__B0NK20Ch__"